import axios from "axios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import closeButton from "../../Assets/Images/close-btn.png";
import { AddFoodApi, AddHealthMessagesApi } from "../../Utils/API/ApiCall";
import { ToastContainer, toast } from "react-toastify";
import { Col, Form, Row } from "react-bootstrap";

const CreateHealth = ({
  images,
  head,
  detail,
  button,
  placeholder,
  onHide,
  ...props
}) => {

  const [healthMessageName, setHealthMessageName] = useState("");
  const [errorEmpty, setErrorEmpty] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChangeBreedName = (e) => {
    e.preventDefault();
    setHealthMessageName(e.target.value);
  };

  const addHealthMessage = async (e) => {
    e.preventDefault();
    let check = true;
    if (!healthMessageName) {
      setErrorEmpty(true);
      setErrorMsg("Health message should not be empty");
      check = false;
    } else if (healthMessageName) {
      if (/^\s+$/.test(healthMessageName) === true) {
        setErrorEmpty(true);
        setErrorMsg("Health message should not be empty");
        check = false;
      } else {
        setErrorEmpty(false);
      }
    } else {
      setErrorMsg(false);
    }

    if (check === true) {
      const data = {
        health_message: healthMessageName,
      };
      const Response = await AddHealthMessagesApi(data);
      if (Response.status == 200) {
        toast.success(Response.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (Response.status == 400) {
        toast.error(Response.message);
      } else {
        toast.error(Response.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    }
  };

  const handleClose = () =>{
    window.location.reload();
  }

  return (
    <>
       <div className="Modal">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <img
              src={closeButton}
              className="closeButton"
              alt="closeButton"
              onClick={handleClose}
            />
            <div className="modal-image">
              <img
                loading="lazy"
                src={images}
                alt="category image"
                className="modal_Head_Image"
              />
            </div>
            <h3>{head}</h3>
            <Form onSubmit={addHealthMessage}>
              <div className="Modal-input">
                <input
                  type="text"
                  placeholder={placeholder}
                  maxLength={100}
                  value={healthMessageName}
                  onChange={handleChangeBreedName}
                ></input>
              </div>
              <p className="err-msg">{errorEmpty ? errorMsg : ""}</p>
              <button className="modal_Button" onSubmit={addHealthMessage}>
                Add
              </button>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default CreateHealth;
